module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book.3a0a7f65.woff2";